import { render, staticRenderFns } from "./client-detail-email.vue?vue&type=template&id=0bc8f3d8&scoped=true"
import script from "./client-detail-email.vue?vue&type=script&lang=js"
export * from "./client-detail-email.vue?vue&type=script&lang=js"
import style0 from "./client-detail-email.vue?vue&type=style&index=0&id=0bc8f3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8f3d8",
  null
  
)

export default component.exports